import { atom } from "jotai";

import { currentBookingAtom } from "../../stores";

export const setBookingDurationAtom = atom(
  null,
  (get, set, payload: { durationMins: number }) => {
    const booking = get(currentBookingAtom);
    if (!booking) return;

    const updatedBooking = {
      ...booking,
      durationMins: payload.durationMins,
    };

    set(currentBookingAtom, updatedBooking);
  }
);
